import { useCallback, useRef } from 'react'
import { Howl } from 'howler'
import notificationSound from './notification_sound.mp3'

const NOTIFICATION_THROTTLE_TIME = 500
export const useNotificationSound = () => {
  const lastPlayed = useRef(Date.now() - NOTIFICATION_THROTTLE_TIME)

  const play = useCallback(() => {
    // This is kind of insane, but safari doesn't allow playing audio without user interaction and when tab is not focused
    // We used to have Audio element here, but it was not working in Safari and this lib does. We could see what they use and copy it later
    const audio = new Howl({ src: [notificationSound] })
    lastPlayed.current = Date.now()
    audio.play()
  }, [])

  const isThrottled = useCallback(
    (timestamp: string | undefined) =>
      new Date(timestamp ?? 0).valueOf() <= lastPlayed.current + NOTIFICATION_THROTTLE_TIME,
    []
  )

  return { lastPlayed, play, isThrottled }
}
